import { isValidCPF, isValidEmail, isValidPhone } from '../../../../utils/validation';
import type { UserIdentificationFormState, UserIdentificationErrors } from '../types/user-identification.types';

export function validateUserIdentification(state: UserIdentificationFormState): UserIdentificationErrors {
  const { formData } = state;
  const errors: UserIdentificationErrors = {};

  // Nome completo
  if (!formData.fullName.trim() || formData.fullName.trim().split(' ').filter(n => n.length > 1).length < 2) {
    errors.fullName = 'Nome completo é obrigatório.';
  }

  // Email
  if (!formData.email.trim()) {
    errors.email = 'Email é obrigatório.';
  } else if (!isValidEmail(formData.email)) {
    errors.email = 'Email inválido.';
  }

  // CPF (condicional)
  if (formData.cpfOnIdentification && !isValidCPF(formData.cpf)) {
    errors.cpf = 'CPF inválido.';
  }

  // Telefone
  if (!formData.phone.trim()) {
    errors.phone = 'Celular é obrigatório.';
  } else if (!isValidPhone(formData.phone)) {
    errors.phone = 'Celular inválido. Use (XX) XXXXX-XXXX.';
  }

  // Data de nascimento — só se o tema pedir (`requestBirthDate`)
  if (formData.requestBirthDate) {
    if (!formData.birth || !formData.birth.trim()) {
      errors.birth = 'Data de nascimento é obrigatória.';
    } else if (!isBirthDateValid(formData.birth)) {
      errors.birth = 'Data de nascimento inválida. Deve ser maior de 18 anos no formato DD/MM/AAAA.';
    }
  }

  return errors;
}

export function isFullNameValid(fullName: string): boolean {
  return Boolean(fullName.trim() && fullName.trim().split(' ').filter(n => n.length > 1).length >= 2);
}

export function isEmailValid(email: string): boolean {
  return Boolean(email.trim() && isValidEmail(email));
}

export function isCpfValid(cpf: string, cpfOnIdentification: boolean): boolean {
  return Boolean(!cpfOnIdentification || (cpf && isValidCPF(cpf)));
}

export function isPhoneValid(phone: string): boolean {
  return Boolean(phone.trim() && isValidPhone(phone));
}

export function isBirthDateValid(birthDate: string): boolean {
  if (!birthDate || birthDate.trim().length !== 10) return false;
  
  const [day, month, year] = birthDate.split('/').map(Number);
  if (!day || !month || !year) return false;
  
  const date = new Date(year, month - 1, day);
  const today = new Date();
  let age = today.getFullYear() - date.getFullYear();
  const monthDiff = today.getMonth() - date.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
    age--;
  }
  
  return age >= 18 && date.getDate() === day && date.getMonth() === month - 1 && date.getFullYear() === year;
}

 